import { __decorate, __metadata } from "tslib";
import { IsArray, IsDateString, IsEnum, IsOptional, IsUUID } from 'class-validator';
import { UUID_VERSION } from '../../type/shared';
import { SortDirection } from '../shared';
import { SharedRecordingsListSortBy } from './SharedRecordingsListSortBy';
export class ListSharedRecordingsForUserBody {
    constructor(courtSystems = [], recordingDate = undefined, sortBy = SharedRecordingsListSortBy.DateShared, sortDirection = SortDirection.Descending) {
        this.courtSystems = courtSystems;
        this.recordingDate = recordingDate;
        this.sortBy = sortBy;
        this.sortDirection = sortDirection;
    }
}
__decorate([
    IsOptional(),
    IsArray(),
    IsUUID(UUID_VERSION, { each: true }),
    __metadata("design:type", Array)
], ListSharedRecordingsForUserBody.prototype, "courtSystems", void 0);
__decorate([
    IsOptional(),
    IsDateString(),
    __metadata("design:type", Object)
], ListSharedRecordingsForUserBody.prototype, "recordingDate", void 0);
__decorate([
    IsEnum(SharedRecordingsListSortBy),
    __metadata("design:type", String)
], ListSharedRecordingsForUserBody.prototype, "sortBy", void 0);
__decorate([
    IsEnum(SortDirection),
    __metadata("design:type", String)
], ListSharedRecordingsForUserBody.prototype, "sortDirection", void 0);
